<template>
  <el-dialog
    class="node-detail-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
  >
    <el-descriptions class="margin-top" :column="1" :border="true">
      <el-descriptions-item v-for="(item, i) in labelList" :key="i">
        <template slot="label">
          {{ item.label }}
        </template>
        <template v-if="item.formatter">
          {{ item.formatter(resultObj[item.value]) }}
        </template>
        <template v-else>
          {{ resultObj[item.value] || $constants.EMPTY }}
        </template>
      </el-descriptions-item>
    </el-descriptions>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleCancel">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'NodeDetail',
  data() {
    return {
      title: '节点基本信息',
      dialogVisible: false,
      labelList: [
        { label: '所属组织', value: 'OrgName' },
        { label: '节点名称', value: 'NodeName' },
        {
          label: '加入时间',
          value: 'createAt',
          formatter: row => {
            return this.formatTime(row)
          }
        },
        { label: '节点ID', value: 'NodeId' },
        { label: '节点IP', value: 'NodeIp' },
        { label: 'RPC端口', value: 'NodeRpcPort' },
        { label: 'P2P端口', value: 'NodeP2pPort' },
        {
          label: '节点类型',
          value: 'Type',
          formatter: row => {
            return this.formatType(row)
          }
        },
        { label: '账本同步方式', value: 'Consensus' }
      ],
      resultObj: {}
    }
  },
  methods: {
    handleCancel() {
      this.dialogVisible = false
    },
    handleOpen(row) {
      this.resultObj = row
      this.dialogVisible = true
    },
    formatTime(row) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', row)
    },
    formatType(row) {
      return row === 0 ? '共识节点' : '普通节点'
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('node-detail-dialog', (), ());
.node-detail-dialog.common-dialog {
  @include adaptation((
    --node-detail-dialog-body-padding-bottom: 20px
  ));
  /deep/ .el-dialog {
    width: var(--common-dialog-medium-width);

    .el-dialog__body {
      padding-bottom: var(--node-detail-dialog-body-padding-bottom);
    }
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);
  }
}
</style>
